<template>
    <div>
        <div v-if="error">
            <div class="alert alert-danger" role="alert">
                {{ $t('Request expired') }}
            </div>
        </div>
        <div v-if="!success">
            <h4> {{  $t('Security alert') }}</h4>
            <p> {{  $t('A new login was detected on your account.') }}</p>
            <div>
                <list-group-skeleton v-if="loading" :rows="3" />
                <list v-else bordered>
                    <list-item class="px-3" :title="`${$t('Account')}:`">
                        <template #text>
                            {{ device.email }}
                        </template>
                    </list-item>
                    <list-item :title="`${$t('Fingerprint')}:`">
                        <template #text>
                            {{ device.fingerprint }}
                        </template>
                    </list-item>
                    <list-item class="px-3" :title="`${$t('Location')}:`">
                        <template #text>
                            {{ device.location }}
                        </template>
                    </list-item>
                    <list-item :title="`${$t('Device type')}:`">
                        <template #text>
                            {{ device.platform }}
                        </template>
                    </list-item>
                    <list-item :title="`${$t('Date')}:`">
                        <template #text>
                            {{ format_date }}
                        </template>
                    </list-item>
                </list>
            </div>
            <div>
                <br>
                <p> {{ $t('Do you recognize this activity?') }}</p>
                <ui-button :loading="closing" class="w-100 mb-0" type="submit" variant="accent" @click="closeSession">
                    {{ $t('No, close session.') }}
                </ui-button>
            </div>
        </div>
        <div v-else-if="success">
            <empty-state img-size="md" img="safe.svg" text="This action helps us protect your account." />
        </div>
    </div>
</template>

<script>
import List from '@/components/ui/list/List';
import ListItem from '@/components/ui/list/ListItem';
import ListGroupSkeleton from '@/components/ui/skeletons/ListGroupSkeleton.vue';
import UiButton from '@/components/ui/buttons/Button.vue';
import EmptyState from '@/components/ui/EmptyState.vue';
import { decrypt } from '@tendencys/encrypter';


export default {
    name: 'ReportDeviceCard',
    components: { List, ListItem, ListGroupSkeleton, UiButton, EmptyState },
    data() {
        return {
            device: {},
            loading: false,
            format_date: '',
            closing: false,
            opening: false,
            counter: 0,
            success: false,
            _vData: {},
            error: false,
        }
    },
    async mounted() {
        const { _v } = this.$route.query;
        if (!_v) {
            this.error = 'The autorization is required.';
        } else {
            this._vData = JSON.parse(decrypt(_v, window.ENV.VUE_APP_TENCRYPT));
            let { token, data } = this._vData;
            this.device = JSON.parse(data);
            this.formatDate(this.device.date);
            this.axiosAccount.defaults.headers.common['Authorization'] = token;
        }
    },
    methods: {
        formatDate(date) {
            let format = new Date(date).toLocaleString();
            this.format_date = format.slice(0, -3);       
        },
        async closeSession() {
            try {
                this.closing = true;
                await this.axiosAccount.post(`/api/accounts/report-device`);
                this.$toasted.global.successMessage('Session closed successfully.');
            } catch (err) {
                this.$toasted.global.errorMessage('Error closing session. Please try again.');
            } finally {
                this.closing = false;
            }
        },
    }
}
</script>

<style lang="scss">
.report-device-card {

    &__empty-message {
        background-color: #eff1f8;
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        width: 100%;
        margin-bottom: 0;
    }

    &__separator {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        position: relative;
    }

    &__separator-text {
        font-size: 14px;
        color: #9093A1;
        font-weight: 500;
        padding-left: 10px;
        padding-right: 10px;

        &::after {
            background-color: #c4c4c4;
            content: '';
            height: 1px;
            left: 0;
            position: absolute;
            top: calc(50% - 1px);
            width: calc(50% - 18px);
        }

        &::before {
            background-color: #c4c4c4;
            content: '';
            height: 1px;
            position: absolute;
            right: 0;
            top: calc(50% - 1px);
            width: calc(50% - 18px);
        }
    }

    &__forgot-password {
        color: $accounts-secondary !important;
        font-weight: 500 !important;
        padding: 0 !important;
        text-align: left;
        font-size: 8px;
        padding-top: 0%;
    }
}
</style>